export const SPACE_REFRESH_INTERVAL_SECONDS = 1 * 60; // 1 minute
export const SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS = 1 * 60; // 1 minute
export const SHARED_BOARDS_REFRESH_INTERVAL_SECONDS = 1 * 60; // 1 minute
export const SHARED_CONTENT_BOARDS_REFRESH_INTERVAL_SECONDS = 1 * 60; // 1 minute
